import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICompetence, ICreateCompetenceRequest, IUpdateCompetenceRequest, IAddUoCompetenceRequest } from 'src/app/shared/models/competence';


@Injectable({ providedIn: 'root' })
export class CompetenceService {

  private readonly apiUrl     = '/api/v1/referentiel/competences';
  private readonly uoCompUrl  = '/api/v1/referentiel/uo-competences';

  constructor(private http: HttpClient) {}

  getAll(): Observable<ICompetence[]> {
    return this.http.get<ICompetence[]>(this.apiUrl);
  }

  create(request: ICreateCompetenceRequest): Observable<ICompetence> {
    return this.http.post<ICompetence>(this.apiUrl, request);
  }

  update(id: string, request: IUpdateCompetenceRequest): Observable<ICompetence> {
    return this.http.patch<ICompetence>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  addUoCompetence(request: IAddUoCompetenceRequest): Observable<void> {
    return this.http.post<void>(this.uoCompUrl, request);
  }

  removeUoCompetence(uoCompetenceId: string): Observable<void> {
    return this.http.delete<void>(`${this.uoCompUrl}/${uoCompetenceId}`);
  }

  getActiveByUo(uniteOrganisationnelleId: string): Observable<ICompetence[]> {
    return this.http.get<ICompetence[]>(
      `/api/v1/referentiel/competences/actives?uniteOrganisationnelleId=${uniteOrganisationnelleId}`
    );
  }

  exportData(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export`, { responseType: 'blob' });
  }
}